"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectOptionIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./Select.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectOptionIcon = function SelectOptionIcon(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-option-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + icon
  }));
};

exports.SelectOptionIcon = SelectOptionIcon;

var Select = function Select(_ref2) {
  var id = _ref2.id,
      options = _ref2.options,
      placeholder = _ref2.placeholder,
      value = _ref2.value,
      onChange = _ref2.onChange,
      filter = _ref2.filter,
      disabled = _ref2.disabled,
      fixedWidth = _ref2.fixedWidth,
      fullWidth = _ref2.fullWidth,
      customToggle = _ref2.customToggle,
      tooltip = _ref2.tooltip,
      overflow = _ref2.overflow,
      positionFixed = _ref2.positionFixed,
      large = _ref2.large;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!isOpen) {
      setTooltipOpen(false);
    }
  }, [isOpen]);

  var toggle = function toggle() {
    return setOpen(function (open) {
      return !open;
    });
  };

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTooltipOpen = _useState4[0],
      setTooltipOpen = _useState4[1];

  var classes = (0, _classNames["default"])({
    fixed: fixedWidth,
    block: fullWidth,
    filter: filter,
    custom: customToggle != null,
    large: large
  });
  var menuClasses = (0, _classNames["default"])({
    filter: filter,
    large: large,
    custom: customToggle != null,
    fixed: positionFixed
  });
  var ref = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      toggleWidth = _useState6[0],
      setToggleWidth = _useState6[1];

  (0, _react.useLayoutEffect)(function () {
    if (ref.current) setToggleWidth(ref.current.offsetWidth);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
    isOpen: isOpen,
    toggle: toggle,
    disabled: disabled,
    className: 'gcl-select ' + classes
  }, customToggle ? /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    id: id,
    tag: "span",
    className: "gcl-select-custom-toggle ".concat(isOpen ? 'open' : '', " ").concat(disabled ? 'disabled' : '')
  }, /*#__PURE__*/_react["default"].cloneElement(customToggle, {
    disabled: disabled
  })) : /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    id: id,
    tag: "div",
    innerRef: ref,
    className: "gcl-select-toggle ".concat(value == null ? 'placeholder' : '', " ").concat(isOpen ? 'open' : '', " ").concat(disabled ? 'disabled' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-select-value"
  }, value != null && value.icon != null && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-select-icon"
  }, value.icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-select-label"
  }, value != null ? value.label : placeholder)), /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon gcl-select-toggle-icon ' + (isOpen ? 'chevron-up' : 'chevron')
  })), tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.Tooltip, {
    target: id,
    isOpen: !isOpen && isTooltipOpen,
    toggle: function toggle() {
      return setTooltipOpen(function (o) {
        return !o;
      });
    }
  }, tooltip), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, {
    className: 'gcl-select-menu gcl-fader ' + menuClasses,
    container: overflow ? 'body' : undefined,
    positionFixed: positionFixed,
    style: {
      width: toggleWidth
    }
  }, options && options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownItem, {
      className: value != null && value.value === o.value ? 'selected' : undefined,
      key: o.value,
      onClick: function onClick() {
        return onChange(o);
      }
    }, filter ? value != null && value.value === o.value && /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon gcl-select-filter-icon sent"
    }) : o.icon != null && /*#__PURE__*/_react["default"].createElement("span", {
      className: "gcl-select-icon"
    }, o.icon), /*#__PURE__*/_react["default"].createElement("span", {
      className: "gcl-select-label"
    }, o.label));
  })));
};

Select.propTypes = {
  id: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].any,
    label: _propTypes["default"].string
  })).isRequired,
  value: _propTypes["default"].shape({
    value: _propTypes["default"].any,
    label: _propTypes["default"].string
  }),
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  filter: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  fixedWidth: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  customToggle: _propTypes["default"].node,
  tooltip: _propTypes["default"].string,
  overflow: _propTypes["default"].bool,
  positionFixed: _propTypes["default"].bool,
  large: _propTypes["default"].bool
};
Select.defaultProps = {
  options: []
};
var _default = Select;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Select/Select.js
// module id = 1915
// module chunks = 0